// Copyright (c) StrangeBee 2024

import React, { ReactElement } from 'react';
import { useLocalMessage } from '@Helpers/';
import ScopeButton from '@Organisms/Search/ScopeButton/ScopeButton';
import { SearchScopeType } from '@Types';
import { ObjectTypeV1 as ObjectType } from 'thehive-sdk';
import { ICONS } from '@Constants/iconsApp';

import './SearchScope.scss';

export const SearchIcons: Record<SearchScopeType, ReactElement> = {
    [ObjectType.ANY]: <ICONS.SettingIcon />,
    [ObjectType.CASE]: <ICONS.CaseIcon />,
    [ObjectType.ALERT]: <ICONS.AlertIcon />,
    [ObjectType.OBSERVABLE]: <ICONS.ObservableIcon />,
    [ObjectType.JOB]: <ICONS.JobIcon />,
    [ObjectType.TASK]: <ICONS.TaskIcon />,
    [ObjectType.LOG]: <ICONS.TaskLogIcon />,
    [ObjectType.AUDIT]: <ICONS.AuditIcon />,
};

interface SearchScopeProps {
    fieldScope?: SearchScopeType;
    setFieldScope: React.Dispatch<React.SetStateAction<SearchScopeType | undefined>>;
}

const SearchScope = ({ fieldScope, setFieldScope }: SearchScopeProps): ReactElement => {
    const i = useLocalMessage();

    return (
        <div className="search-scope">
            <div className="search-scope__container">
                <div className="search-scope__title">{i('search.scope.title')}</div>
                <div className="search-scope__list">
                    {Object.keys(SearchIcons).map(
                        (label) =>
                            label !== ObjectType.AUDIT && (
                                <ScopeButton
                                    key={`search-scope-${label}`}
                                    label={i(`search.scope.${label}.label`)}
                                    icon={SearchIcons[label as SearchScopeType]}
                                    active={fieldScope === label}
                                    onClick={(): void => setFieldScope(label as SearchScopeType)}
                                />
                            ),
                    )}
                </div>
            </div>
        </div>
    );
};

export default SearchScope;
